import React from "react";
import { useHistory } from "react-router-dom";
import Footer from "../layout/Footer";
import Header from "../layout/Header";

/**
 * Objective Component
 * Main menu for selecting Circular Tunnel functionality
 */
const Objective = (props) => {
  const history = useHistory();
  return (
    <div id="page">
      <Header onBack={() => history.push("/choosetype")} />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="row text-center mb-3 justify-content-center">
          <div
            onClick={() => {
              props.setstep("orientation");
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                props.setstep("orientation");
              }
            }}
            className="col-6"
            style={{ cursor: "pointer" }}
          >
            <div className="card card-style mb-3">
              <i className="fas fa-chart-area color-magenta-dark fa-3x mt-5"></i>
              <h3 className="pt-4">Plotting Discontinuity Trace</h3>
              <p className="font-11 opacity-50 mt-n2">
                Plotting Discontinuity Trace on the Tunnel Log
              </p>
              <p className="mb-0 pb-0 font-10 opacity-40">Tap to View</p>
            </div>
          </div>
          {/* The Computing Discontinuity Orientation activity now lives in the
              DisDip web tool, and the orientation-source screen covers
              orientation from face logs or known chainages; its components
              stay routable here. */}
        </div>
      </div>
    </div>
  );
};

export default Objective;
